const LOCAL_URL = "http://localhost:8080";

export const appConfig = {
  url: process.env.NODE_ENV === "development" ? LOCAL_URL : "",
};
